// src/pages/Home.jsx
import React from "react";
import "./Home.css";
import labTest from "../asset/images/LabTests.avif";
import bloodBanks from "../asset/images/Blood Banks.avif";
import Diogonstic from "../asset/images/Diogonstic.avif";
import Medicine from "../asset/images/MedicineDeliveries.avif";
import headlthcareServicesOnline from "../asset/images/healthcareServicesOnline.avif";
import { Card } from "antd";
import Footer from "../components/Footer";
const { Meta } = Card;

const HomeSectionWithCards = ({ cardsData }) => {
  return (
    <div className="home-section-container">
      {cardsData.map((card, index) => (
        // <div key={index} className="card">
        //   <img src={card.image} alt={card.header} className="card-image" />
        //   <h2 className="card-header">{card.header}</h2>
        //   <p className="card-content">{card.content}</p>
        // </div>
        <Card
          hoverable
         className="card"
          cover={
            <img
            src={card.image} alt={card.header}
            />
          }
        >
          <Meta title={<h2 style={{wordBreak: 'break-word', whiteSpace: 'normal', overflowWrap: 'anywhere'}}>{card.header}</h2>} description={<p>{card.content}</p>} />
        </Card>
      ))}
    </div>
  );
};
const Home = () => {
  const cardsData = [
    {
      image: labTest,
      header: "Lab Tests",
      content:
        "Lab test at your door step get your lab test done from comfort of your home with our reliable and hassle free doorstep service. From Sample Collection to Fast & Accurate Results we provide seamless diagnostic Services. Up to 60% off",
    },
    {
      image: bloodBanks,
      header: "Blood Banks ",
      content:
        "Every drop counts: Save Lives with us. Your one-stop platform for blood donation, blood requests & spreading hope. Trusted platform connecting donors & recipients to ensure life-saving blood is always available when needed. A dedicated initiative to bridge the gap between blood donors & those in urgent need. Find nearby blood bank & check for availability of the required blood product. Find nearby donation camp & donate safely. Secure & hygienic blood donation practices",
    },
    {
      image: Medicine,
      header: "Medicine Deliveries",
      content:
        "Your medicines, delivered fast & easy. Maximum discounts on all medicines. Wide range of medicines & healthcare products. Easy ordering process with doorstep delivery. Verified and authentic products.",
    },
    {
      image: Diogonstic,
      header: "Diagnostic Imaging Centres",
      content:
        "Diagnostic Imaging Centres. Your one-stop destination for trusted diagnostic imaging centres. Certified diagnostic imaging centres near you. We make it easy for you to find quality imaging services quickly & conveniently. Up to 50% off on all diagnostic imaging services..",
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <div className="home-container">
        <div className="image-overlay"></div>

        <div className="content-container">
          <h1>Healthcare Services at Your Fingertips</h1>
          <div className="parent-content-box">
            <div className="content-box">
              <h2>Lab Tests</h2>
              <p>
                Compare prices and ratings of labs near you. Book tests at up to
                60% off, with doorstep sample collection in 1 hour, fastest and
                accurate results
              </p>
            </div>
            <div className="content-box">
              <h2>Blood Banks</h2>
              <p>
                Compare blood release charges at your nearest blood bank, find
                nearby options, and check the availability of blood products
                instantly.
              </p>
            </div>
            <div className="content-box">
              <h2>Medicines Deliveries</h2>
              <p>
                Compare prices of medicines and ratings of pharmacies near you,
                order medicines online at maximum discounts, and get delivery
                within 1 hour.
              </p>
            </div>
            <div className="content-box">
              <h2> Diagnostic Imaging Centres</h2>
              <p>
                Compare prices and ratings of imaging centres near you, get up
                to 50% off on services, and book appointments easily.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="home-section-service-container-test">
        <HomeSectionWithCards key={Math.random} cardsData={cardsData} />
      </div>
      {/* <div className="home-healthcare-services">
        <h1>Healthcare Services Online</h1>
        <p>
          Access medical services conveniently from your phone with Abomed's
          healthcare solutions.
        </p>
        <div className="home-healthcare-services-service">
          <img
            src={headlthcareServicesOnline}
            alt="Healthcare Services Online"
          />
          <div className="home-healthcare-services-service-right-content">
            <div className="home-healthcare-services-service-card">
              <h2>Emergency Services</h2>
              <p style={{ color: "gray" }}>
                Get immediate assistance for urgent medical needs with our
                reliable emergency service options.
              </p>
            </div>
            <div>
              <h2>Telemedicine Consultations</h2>
              <p style={{ color: "gray" }}>
                Connect with healthcare professionals from the comfort of your
                home anytime you need.
              </p>
            </div>
            <div>
              <h2>Home Healthcare Services</h2>
              <p style={{ color: "gray" }}>
                Receive personalized healthcare services delivered right to your
                doorstep for your convenience.
              </p>
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  );
};
export default Home;
